export interface Place {
  id: string;
  name: string;
  category: string;
  area: string;
  tags: string[];
  price: string;
  duration: string;
  address: string;
  hours: string;
  parking: string;
  images: string[];
  photoSpots: string[];
  specialties?: string[];
  tips: string[];
  status: string[];
  recommended?: boolean;
  recommendedType?: string;
}

export const places: Place[] = [
  {
    id: 'deep-blue',
    name: '深蓝计划',
    category: '咖啡',
    area: '梅溪镇',
    tags: ['网红咖啡', '拍照', '矿坑'],
    price: '人均 68',
    duration: '1.5-2小时',
    address: '安吉县梅溪镇红庙村',
    hours: '10:00-18:00',
    parking: '周末紧张，建议早点到',
    images: [
      'https://images.unsplash.com/photo-1502082553048-f009c37129b9?w=400&h=300&fit=crop',
      'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=400&h=300&fit=crop',
    ],
    photoSpots: ['矿坑湖面', '白色建筑外立面', '高处平台', '咖啡杯与湖面同框'],
    tips: [
      '周末和节假日容易排队，建议平日前往',
      '咖啡口味评价分化，主要价值是场景和拍照',
      '热门时段停车压力较大',
      '晴天更适合拍照，雨天体验下降',
    ],
    status: ['适合拍照', '网红打卡'],
    recommended: true,
    recommendedType: '本周热门',
  },
  {
    id: 'waterfall-coffee',
    name: '瀑布咖啡',
    category: '咖啡',
    area: '山川乡',
    tags: ['山谷咖啡', '瀑布', '自然'],
    price: '人均 45',
    duration: '1-1.5小时',
    address: '安吉县山川乡高家堂村',
    hours: '09:00-17:00',
    parking: '有免费停车场',
    images: [
      'https://images.unsplash.com/photo-1533240332313-0db49b459ad6?w=400&h=300&fit=crop',
    ],
    photoSpots: ['瀑布前石阶', '山谷全景', '咖啡露台', '溪流旁木桥'],
    tips: [
      '雨季瀑布水量大，体验最佳',
      '建议带薄外套，山谷内温度低',
      '蚊虫较多，备好驱蚊用品',
    ],
    status: ['雨天可去', '避暑'],
  },
  {
    id: 'cloud-prairie',
    name: '云上草原',
    category: '景点',
    area: '山川乡',
    tags: ['高山', '草原', '刺激项目'],
    price: '门票 180',
    duration: '4-6小时',
    address: '安吉县山川乡高家堂村',
    hours: '08:30-17:00',
    parking: '景区停车场充足',
    images: [
      'https://images.unsplash.com/photo-1500534623283-312aade485b7?w=400&h=300&fit=crop',
    ],
    photoSpots: ['草原全景', '悬崖秋千', '彩虹滑草道', '山顶云海'],
    tips: [
      '海拔1168米，温差大需带外套',
      '索道排队时间长，建议早到',
      '部分项目有身高体重限制',
      '晴天才开放全部项目',
    ],
    status: ['亲子友好', '户外', '需预约'],
  },
  {
    id: 'bamboo-sea',
    name: '中国大竹海',
    category: '景点',
    area: '天荒坪',
    tags: ['竹林', '电影取景', '徒步'],
    price: '门票 58',
    duration: '2-3小时',
    address: '安吉县天荒坪镇五鹤村',
    hours: '08:00-16:30',
    parking: '景区门口有停车场',
    images: [
      'https://images.unsplash.com/photo-1502082553048-f009c37129b9?w=400&h=300&fit=crop',
    ],
    photoSpots: ['竹海长廊', '卧虎藏龙取景地', '山顶观景台', '竹林小道'],
    tips: [
      '电影《卧虎藏龙》取景地，竹林很壮观',
      '建议走环线，全程约1.5小时',
      '夏季竹林内很凉爽',
      '穿舒适运动鞋',
    ],
    status: ['亲子友好', '避暑', '人少'],
  },
  {
    id: 'nature-museum',
    name: '浙江自然博物院安吉馆',
    category: '景点',
    area: '递铺街道',
    tags: ['博物馆', '亲子', '室内'],
    price: '免费',
    duration: '3-4小时',
    address: '安吉县递铺街道梅园路',
    hours: '09:00-17:00（周一闭馆）',
    parking: '地下停车场',
    images: [
      'https://images.unsplash.com/photo-1564399579883-451a5d44ec08?w=400&h=300&fit=crop',
    ],
    photoSpots: ['恐龙化石展厅', '海洋展厅', '生态馆穹顶', '4D影院入口'],
    tips: [
      '亚洲最大自然博物馆之一',
      '需提前在公众号预约',
      '馆内有餐厅，也可以自带食物',
      '非常适合雨天游玩',
    ],
    status: ['亲子友好', '雨天可去', '免费'],
  },
  {
    id: 'zhongnan-baicaoyuan',
    name: '中南百草原',
    category: '景点',
    area: '递铺街道',
    tags: ['动物园', '植物园', '游乐园'],
    price: '门票 150',
    duration: '全天',
    address: '安吉县递铺街道马鞍山村',
    hours: '08:00-17:00',
    parking: '大型停车场',
    images: [
      'https://images.unsplash.com/photo-1589656966895-2f33e7653819?w=400&h=300&fit=crop',
    ],
    photoSpots: ['狮虎表演区', '植物园温室', '摩天轮', '跑马场'],
    tips: [
      '集动物园、植物园、游乐园于一体',
      '建议安排一整天',
      '景区很大，可租电瓶车',
      '带孩子的强烈推荐',
    ],
    status: ['亲子友好', '宠物友好', '团建'],
  },
  {
    id: 'yucun',
    name: '余村',
    category: '景点',
    area: '天荒坪',
    tags: ['美丽乡村', '绿水青山', '文化'],
    price: '免费',
    duration: '2-3小时',
    address: '安吉县天荒坪镇余村',
    hours: '全天开放',
    parking: '村口有免费停车场',
    images: [
      'https://images.unsplash.com/photo-1501785888041-af3ef285b470?w=400&h=300&fit=crop',
    ],
    photoSpots: ['村口石碑', '荷花池', '竹林步道', '两山理念会址'],
    tips: [
      '两山理念发源地，乡村建设典范',
      '村子不大，步行即可',
      '周边有农家乐可吃饭',
      '适合喜欢慢节奏的人',
    ],
    status: ['免费', '人少', '亲子友好'],
  },
  {
    id: 'white-tea-view',
    name: '白茶观景平台',
    category: '景点',
    area: '溪龙乡',
    tags: ['茶园', '观景', '拍照'],
    price: '免费',
    duration: '1-2小时',
    address: '安吉县溪龙乡黄杜村',
    hours: '全天开放',
    parking: '路边可停',
    images: [
      'https://images.unsplash.com/photo-1599526588836-a45f63a66ce0?w=400&h=300&fit=crop',
    ],
    photoSpots: ['茶园全景', '观景平台', '采茶体验区', '白茶制作工坊'],
    tips: [
      '春季采茶季最美，4-5月最佳',
      '可以体验采茶和制茶',
      '附近可买正宗安吉白茶',
      '建议清晨或傍晚去，光线好',
    ],
    status: ['适合拍照', '人少', '免费'],
  },
  {
    id: 'xiaohangkeng',
    name: '小杭坑',
    category: '露营',
    area: '孝丰镇',
    tags: ['露营', '山谷', '溪流'],
    price: '露营 200-400',
    duration: '过夜',
    address: '安吉县孝丰镇夏阳村',
    hours: '全天开放',
    parking: '营地有停车场',
    images: [
      'https://images.unsplash.com/photo-1533240332313-0db49b459ad6?w=400&h=300&fit=crop',
    ],
    photoSpots: ['山谷营地', '溪流浅滩', '星空露营', '晨雾竹林'],
    tips: [
      '网红露营基地，需提前预约',
      '自带装备或租用均可',
      '山谷信号不好，提前下载地图',
      '夜间温度低，注意保暖',
    ],
    status: ['露营', '宠物友好', '人少'],
  },
  {
    id: 'bamboo-park',
    name: '安吉竹博园',
    category: '景点',
    area: '递铺街道',
    tags: ['熊猫', '竹林', '科普'],
    price: '门票 80',
    duration: '2-3小时',
    address: '安吉县递铺街道灵峰南路',
    hours: '08:00-16:30',
    parking: '景区停车场',
    images: [
      'https://images.unsplash.com/photo-1587061949409-02df41d5e562?w=400&h=300&fit=crop',
    ],
    photoSpots: ['熊猫馆', '竹林迷宫', '竹文化博物馆', '竹筏漂流'],
    tips: [
      '可以看大熊猫和小熊猫',
      '适合带小朋友科普教育',
      '夏季竹林凉爽宜人',
      '景区内有竹制品商店',
    ],
    status: ['亲子友好', '适合团建'],
  },
  {
    id: 'laolijia',
    name: '老李家土菜馆',
    category: '吃饭',
    area: '递铺街道',
    tags: ['土菜', '地道', '农家'],
    price: '人均 80',
    duration: '1小时',
    address: '安吉县递铺街道胜利西路',
    hours: '10:30-20:30',
    parking: '路边可停',
    images: [
      'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=400&h=300&fit=crop',
    ],
    photoSpots: [],
    specialties: ['土鸡汤', '鲜笋煲', '杂鱼煲', '农家红烧肉'],
    tips: [
      '本地人常去的土菜馆',
      '招牌土鸡汤非常鲜美',
      '节假日建议提前订位',
      '分量足，点菜不要贪多',
    ],
    status: ['停车方便', '适合团建'],
    recommended: true,
    recommendedType: '顺路吃饭推荐',
  },
  {
    id: 'alujia',
    name: '阿露佳·舌尖上的安吉菜',
    category: '吃饭',
    area: '递铺街道',
    tags: ['创意菜', '特色', '精致'],
    price: '人均 120',
    duration: '1-1.5小时',
    address: '安吉县递铺街道胜利东路',
    hours: '11:00-21:00',
    parking: '店旁有停车场',
    images: [
      'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=400&h=300&fit=crop',
    ],
    photoSpots: [],
    specialties: ['竹香土鸡锅', '安吉鲜笋煲', '杂鱼煲', '茶叶大虾'],
    tips: [
      '安吉创意菜代表餐厅',
      '竹香土鸡锅是必点',
      '环境比普通土菜馆更好',
      '适合宴请或特殊场合',
    ],
    status: ['停车方便', '适合拍照'],
  },
  // 新增：天荒坪农家乐（用于三天两夜和四天路线D3/D4午餐节点）
  {
    id: 'tianhuangping-food',
    name: '天荒坪农家乐',
    category: '吃饭',
    area: '天荒坪',
    tags: ['土菜', '地道', '农家', '大竹海附近'],
    price: '人均 70',
    duration: '1-1.5小时',
    address: '安吉县天荒坪镇大竹海景区附近',
    hours: '10:00-20:00',
    parking: '路边可停',
    images: [
      'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=400&h=300&fit=crop',
    ],
    photoSpots: [],
    specialties: ['竹香土鸡锅', '安吉鲜笋煲', '溪鱼', '农家土菜'],
    tips: [
      '大竹海附近有很多地道农家乐',
      '竹香土鸡锅、鲜笋煲是当地必吃菜',
      '旺季建议提前电话订位',
      '分量足，适合一家人用餐',
    ],
    status: ['停车方便', '亲子友好', '团建'],
  },
  // 新增：阿丽拉安吉（高端度假酒店）
  {
    id: 'alila-anji',
    name: '阿丽拉安吉',
    category: '民宿',
    area: '天荒坪',
    tags: ['设计感', '高端', '度假', '无边泳池'],
    price: '人均 600+',
    duration: '过夜',
    address: '安吉县天荒坪镇大竹海景区附近',
    hours: '24小时',
    parking: '酒店专属停车场',
    images: [
      'https://images.unsplash.com/photo-1587061949409-02df41d5e562?w=400&h=300&fit=crop',
    ],
    photoSpots: ['无边泳池', '山居露台', '竹林景观房', '酒店大堂'],
    tips: [
      '阿丽拉（Alila）品牌以设计感著称',
      '建议提前预约，旺季房源紧张',
      '酒店自带餐厅，也可以去附近农家乐',
      '无边泳池拍照非常出片',
    ],
    status: ['设计感', '高端', '适合拍照'],
    recommended: true,
    recommendedType: '度假民宿推荐',
  },
];

export const categoryTabs = [
  '全部', '吃饭', '咖啡', '景点', '民宿', '亲子', '露营', '团建', '拍照',
];

export const filterTags = [
  '亲子友好', '雨天可去', '停车方便', '适合拍照', '人少', '宠物友好', '适合团建',
];
